/**
 * Preloader component
 */

/** Dependencies -------------------------------------------- */

// External

import classNames from 'classnames'

// Internal

import { useAppState } from '../state'

import LogoSvg from '../../../img/svg/_brand-logo.svg'

/** Main ---------------------------------------------------- */

const baseClassName = 'preloader'

export default function Preloader() {

    const isLoading = useAppState( ( state ) => state.isLoading )

    const consolidatedClassName = classNames(
        baseClassName,
        { 'is-inactive': ! isLoading }
    )

    return (

        <div className={ consolidatedClassName }>
            <div className={ `${baseClassName}__logo-container` }>
                <LogoSvg className={ `${baseClassName}__logo` }/>
            </div>
        </div>
    )
}
